// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"1905c85f6093870dd344","303":"52929b104be128f959fd","495":"06ab31895af42c2c5379"}[chunkId] + ".js";
};